import { flatMap, head, join, map, split, tail } from "lodash";
import { getAffectColor } from "@linkfluence/models/affect";
import { Facet } from "@linkfluence/models/facet";
import { CloudTerm, SearchFragmentTerm } from "./search";

export const getAffectLabel = (id: string) => join(tail(split(id, ".")), " ");

const getPolarity = (id: string) => head(split(id, "."));

const getPrefixFromKeywordType = (term: CloudTerm) => {
  switch (term) {
    case Facet.Mentions:
    case Facet.SignificantMentions:
    case Facet.EmergingMentions:
      return "@";
    case Facet.Hashtags:
    case Facet.SignificantHashtags:
    case Facet.EmergingHashtags:
      return "#";
    default:
      return "";
  }
};

const formatKeywordLabel = (term: CloudTerm, label: string) => {
  label = (label || "") + "";
  return getPrefixFromKeywordType(term) + label.split(".").join(" ");
};

export function getFormatedCloud(
  cloud: SearchFragmentTerm["data"]["aggs"][Facet.Hashtags]["values"],
  term: CloudTerm
) {
  return flatMap(
    map(cloud, (entry) => {
      return {
        id: entry.key,
        label:
          term === Facet.Affects
            ? getAffectLabel(entry.key)
            : formatKeywordLabel(term, entry.key),
        polarity: getPolarity(entry.key),
        counts: entry.counts,
        category: term,
        color: term === Facet.Affects ? getAffectColor(entry.key) : null,
      };
    })
  );
}
